<div class="form-wrapper">
  <h2 class="form-title">{{ 'login-page.login.submit' | translate }}</h2>
  <p class="form-subtitle">{{ 'login-page.login.title' | translate }}</p>


  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <!-- E-mail -->
    <div class="field-group">
      <label class="field-label">{{ 'forgot.title-mail' | translate }}</label>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="seu@email.com"
          autocomplete="email"
        />
        @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
          <mat-error>{{ 'global.validate.mail-required' | translate }}</mat-error>
        } @else if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
          <mat-error>{{ 'global.validate.mail-error' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Password -->
    <div class="field-group">
      <div class="password-label-row">
        <span class="field-label">{{ 'register.title-password' | translate }}</span>
        <button
          type="button"
          class="forgot-link"
          (click)="changeView.emit('forgot-password')"
        >
          {{ 'login-page.login.forgot-link' | translate }}
        </button>
      </div>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input
          matInput
          [type]="isPasswordVisible ? 'text' : 'password'"
          formControlName="password"
          autocomplete="current-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="togglePassword()"
          [attr.aria-label]="(isPasswordVisible ? 'login-page.login.hide-password' : 'login-page.login.show-password') | translate"
        >
          <mat-icon>{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
          <mat-error>{{ 'global.validate.password-required' | translate }}</mat-error>
        } @else if (form.get('password')?.hasError('minlength') && form.get('password')?.touched) {
          <mat-error>{{ 'global.validate.password-minlength' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Submit button -->
    <button
      mat-flat-button
      type="submit"
      class="submit-btn full-width"
      [disabled]="isLoading"
    >
      @if (isLoading) {
        <mat-spinner diameter="20" />
      } @else {
        {{ 'login-page.login.submit' | translate }}
      }
    </button>
  </form>

  <!-- Footer -->
  <div class="card-footer">
    <p class="footer-link-text">
      {{ 'login-page.login.no-account' | translate }}
      <button type="button" class="link-btn" (click)="changeView.emit('register')">
        {{ 'login-page.login.create-account' | translate }}
      </button>
    </p>
  </div>
</div>
